import React from 'react';
import PropTypes from 'prop-types';

import PLPMeta from '../../../utils/meta';
import PLPPageHeader from '../../../organs/plp-page-header';
import { Page } from '../../../theme/page';

import withPLP, { withPLPServerSideProps } from '../../../organisms/products';
import PLPGrid from '../../../tissues/product-grid';

const LPC = (props) => {
  // `pageKey` is needed in order to trigger a re-render and state reset in all child
  // components when the URL changes as a consequence of modifying facets or sorting order.
  const pageKey = `${props.filters ? props.filters?.join(' ') : ''} ${props.sort}`;

  return (
    <Page id="maincontent" key={pageKey}>
      <PLPMeta {...props} />
      <PLPPageHeader {...props} />
      <PLPGrid {...props} taxonProducts />
    </Page>
  );
};

export const getServerSideProps = withPLPServerSideProps((ctx, noResults) => {
  if (noResults) {
    return {
      redirect: {
        destination: '/',
        permanent: true
      }
    };
  }
  return {};
});

LPC.propTypes = {
  filters: PropTypes.array.isRequired,
  sort: PropTypes.string.isRequired
};

export default withPLP(LPC);
